import { useQuery } from 'react-query';

import getSurveyQuestionsById from 'api/survey/getSurveyQuestionsById';
import getSurveysList from 'api/survey/getSurveysList';

interface ISurveyResult {
  surveyList: number[] | null;
  surveyQuestions: ISurveyQuestion[];
}

const useSurvey = (): ISurveyResult => {
  const { data: surveyList = [] } = useQuery({
    queryKey: ['api/survey/get'],
    queryFn: getSurveysList,
  });

  const { data: surveyQuestions = [] } = useQuery({
    queryKey: ['/api/survey/questions/', surveyList?.[0]],
    queryFn: () => getSurveyQuestionsById(surveyList?.[0] || 0),
    enabled: !!surveyList?.[0],
  });

  return {
    surveyList,
    surveyQuestions,
  };
};

export default useSurvey;
